/** @jsx jsx */
import { forwardRef } from "react"

import { jsx } from "@trueskin-web/theme"

import Button from "../button"

const CardCta = forwardRef((props, ref) => (
  <Button ref={ref} sx={{ borderRadius: 8 }} {...props} />
))

export default CardCta
